// Pre-launch switch. While this is true, every public page in the lab serves
// the coming-soon holding page; flip it to false on launch day and the real
// home, demos and about page come back untouched.
export const COMING_SOON = true;

// Pre-launch signups carry this extra Systeme tag on top of
// `SEGMENT: Jewish Music Lab`. SEGMENT: is reserved for top-level mailing
// lists, so the waitlist gets its own prefix.
export const WAITLIST_TAG = "WAITLIST: Jewish Music Lab";
